// Credits System Types
// Used for AI analysis purchases and rewards

export interface CreditBalance {
  userId: string;
  balance: number; // Current available credits
  lifetimeEarned: number; // Total credits earned (for stats)
  lifetimeSpent: number; // Total credits spent (for stats)
  lastUpdated: Date;
}

export interface CreditTransaction {
  id: string;
  userId: string;
  amount: number; // Positive for earning, negative for spending
  type: 'purchase' | 'reward' | 'analysis' | 'referral' | 'milestone' | 'daily_login' | 'admin_grant';
  description: string;
  relatedEntity?: {
    type: 'conversation' | 'referral' | 'user' | 'goal';
    id: string;
  };
  createdAt: Date;
  metadata?: Record<string, any>;
}

// Credit pricing and rewards
export const CREDIT_COSTS = {
  CONVERSATION_ANALYSIS: 5,
} as const;

export const CREDIT_REWARDS = {
  // Referral rewards (per successful referral step)
  REFERRAL_SIGNUP: 10,
  REFERRAL_ONBOARDING_COMPLETE: 15,
  REFERRAL_FIRST_CONVERSATION: 25,
  REFERRAL_EXPERT_STATUS: 50,
  
  // Activity rewards
  DAILY_LOGIN_STREAK_7: 5,
  DAILY_LOGIN_STREAK_30: 25,
  FIRST_CONVERSATION: 10,
  CONVERSATION_MILESTONE_10: 50,
  CONVERSATION_MILESTONE_25: 100,
  
  // Expert status rewards
  EXPERT_STATUS_VERIFIED: 25,
  EXPERT_STATUS_EXPERT: 50,
  EXPERT_STATUS_TOP: 100,
} as const;
